// UPI app URL detection for the payment gateway InAppBrowser (see mf-payment.tsx#onMobileRedirect).
//
// Android: only the known UPI schemes are handled; the native InAppBrowser patch in the
// Cordova project covers the same list.
// iOS: gateways may use app-specific schemes that aren't in the list (e.g. gpay://), and a
// WKWebView load of an unknown scheme fails silently. So on iOS any non-web scheme is
// treated as an app link and handed to the OS.

const UPI_SCHEMES = ['upi', 'phonepe', 'paytmmp', 'tez', 'credpay', 'bhim'];
const WEB_SCHEMES = ['http', 'https', 'about', 'data', 'blob', 'javascript', 'file'];

const KNOWN_SCHEME_PATTERN = `^(?:${UPI_SCHEMES.join('|')})://`;
const ANY_APP_SCHEME_PATTERN = `^(?!(?:${WEB_SCHEMES.join('|')}):)[a-z][a-z0-9+.-]*:`;

// Regex source (case-insensitive) matching URLs that should open a native app.
export const appSchemePattern = (isIOS: boolean): string =>
    isIOS ? ANY_APP_SCHEME_PATTERN : KNOWN_SCHEME_PATTERN;

// Returns the app URL to dispatch, or null if the URL should load in the WebView.
// Handles gateways that wrap UPI URLs (e.g. "http://upi://pay?...").
export const extractUpiUrl = (rawUrl: string, isIOS: boolean): string | null => {
    const lower = rawUrl.toLowerCase();
    for (const scheme of UPI_SCHEMES) {
        const idx = lower.indexOf(`${scheme}://`);
        if (idx !== -1) return rawUrl.substring(idx);
    }
    if (isIOS && new RegExp(ANY_APP_SCHEME_PATTERN, 'i').test(rawUrl)) return rawUrl;
    return null;
};

// iOS NSURL (before iOS 17) rejects URLs with raw spaces, e.g. "pn=KFin Technologies".
// Only spaces are encoded so already-encoded URLs are not double-encoded.
export const normalizeUpiUrl = (url: string): string => url.replace(/ /g, '%20');
